import { toString } from "../../../lib/utils/string";
export const confirmAtom = {
  id: 'uicore:confirm',
  name: '弹出确认框',
  category: 'UI交互',
  paramsSchema: {
    type: 'object',
    fields: [{
      id: 'text',
      type: 'string',
      title: '文案',
      default: '真的要执行操作吗？',
      ui: {
        settings: {
          multipleLine: true
        }
      }
    }, {
      id: 'abortIfRejected',
      type: 'boolean',
      title: '选择了“否”就终止流程',
      default: true
    }]
  },
  returnValue: '用户是否确认（布尔值）',
  execute: async (ctx, params) => {
    const uc = ctx.uc;
    const confirmed = await uc.$confirm({
      content: toString(params.text)
    });
    if (!confirmed && params.abortIfRejected) ctx.abort();
    return confirmed;
  }
};
//# sourceMappingURL=confirmAtom.js.map
